// extracted by mini-css-extract-plugin
export default {"notFoundWrapper":"not-found-message_notFoundWrapper__hlIZ-","notFound":"not-found-message_notFound__TecTq"};